function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { grey3, spacing16 } from "@churchofjesuschrist/eden-style-constants";
import { dir } from "@churchofjesuschrist/eden-styled-helpers";
import { InternalUseOnlyRangeInput } from "./RangeInput";
import { RangeInputContext } from "./rangeInputState";
export const InternalUseOnlyMultiRangeField = styled.div.withConfig({
  componentId: "sc-8rq8jq-0"
})(["position:relative;isolation:isolate;height:", ";& ", "{position:absolute;&:first-child{isolation:auto;z-index:2;background:linear-gradient( to right,", " 0%,", " var(--lower-range-percentage),rgba(0,0,0,0) var(--lower-range-percentage),rgba(0,0,0,0) 100% );", "}&:last-child{isolation:auto;}&:last-child::after{content:\"\";position:absolute;top:50%;inset-inline-end:0;transform:translateY(-50%);height:", ";width:calc(100% - var(--lower-range-percentage));z-index:3;}}"], spacing16, InternalUseOnlyRangeInput, grey3, grey3, dir("rtl")`
        background: linear-gradient(
          to left,
          ${grey3} 0%,
          ${grey3}
          var(--lower-range-percentage),
          rgba(0,0,0,0) var(--lower-range-percentage),
          rgba(0,0,0,0) 100%
        );
      `, spacing16);

/**
 * Used to compose two RangeInput elements into a single slider.
 */
const MultiRangeField = _ref => {
  let {
    min = "0",
    max = "100",
    step = "1",
    children,
    ...props
  } = _ref;
  const handleChange = event => {
    const target = event.target;
    const targetValue = target.value;
    const childrenArray = Array.from(target.parentNode.children);
    const index = childrenArray.indexOf(target);
    if (index === 0 && parseFloat(targetValue) >= parseFloat(childrenArray[1].value)) {
      childrenArray[0].value = (parseFloat(childrenArray[1].value) - parseFloat(step)).toString();
    } else if (index === 1 && parseFloat(targetValue) <= parseFloat(childrenArray[0].value)) {
      childrenArray[1].value = (parseFloat(childrenArray[0].value) + parseFloat(step)).toString();
    }
  };
  return /*#__PURE__*/React.createElement(InternalUseOnlyMultiRangeField, _extends({
    onInput: handleChange
  }, props), /*#__PURE__*/React.createElement(RangeInputContext.Provider, {
    value: {
      min,
      max,
      step
    }
  }, children));
};
MultiRangeField.propTypes = {
  /** The lowest value in the range of permitted values. Must be less than or equal to the value of the `max` prop. Overrides any `min` prop passed to either `<RangeInput>` child. */
  min: PropTypes.string,
  /** The greatest value in the range of permitted values. Must be greater than or equal to the value of the `min` prop. Overrides any `max` prop passed to either `<RangeInput>` child. */
  max: PropTypes.string,
  /** A number specifying the granularity that the value must adhere to. A string value of "any" means that no stepping is implied, and any value is allowed (while still respecting `min` and `max`).  */
  step: PropTypes.string,
  /** Must be two `<RangeInput>` elements where the first represents the "lower" value and the second represents the "upper" value selected within the range. */
  children: PropTypes.node.isRequired
};
export default MultiRangeField;